(() => {
/**
 * Find an HTML element by selector.
 *
 * @param {string} selector The selector.
 * @returns {HTMLElement | null} The element or null if not found.
 */ function $776ab16a6a692098$export$77701944e3c77bc3(selector) {
    const el = document.querySelector(selector);
    if (el instanceof HTMLElement) return el;
    return null;
}
function $776ab16a6a692098$export$c1ead522ca0e4e3c(selector) {
    const nodes = document.querySelectorAll(selector);
    const els = [];
    for(let i = 0; i < nodes.length; i++){
        const el = nodes[i];
        if (el instanceof HTMLElement) els.push(el);
    }
    return els;
}
function $776ab16a6a692098$export$4e5337e1a9674b6(selector) {
    const el = document.querySelector(selector);
    if (el instanceof HTMLInputElement) return el;
    return null;
}
function $776ab16a6a692098$export$276904e442ba468d(selector) {
    const nodes = document.querySelectorAll(selector);
    const els = [];
    for(let i = 0; i < nodes.length; i++){
        const el = nodes[i];
        if (el instanceof HTMLInputElement) els.push(el);
    }
    return els;
}


(function($) {
    const page = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".udb-onboarding-page");
    const buttonsWrapper = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".onboarding-heatbox .heatbox-footer");
    const skipButton = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".onboarding-heatbox .skip-button");
    const saveButton = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".onboarding-heatbox .save-button");
    const subscribeButton = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".onboarding-heatbox .subscribe-button");
    const skipDiscount = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".udb-skip-discount a");
    const contentAfterSubscribe = (0, $776ab16a6a692098$export$c1ead522ca0e4e3c)("[data-udb-show-on='subscribe']");
    const contentAfterSkipDiscount = (0, $776ab16a6a692098$export$c1ead522ca0e4e3c)("[data-udb-show-on='skip-discount']");
    const discountNotif = (0, $776ab16a6a692098$export$77701944e3c77bc3)(".onboarding-heatbox .udb-discount-notif");
    const slideIndexes = [
        "modules",
        "subscription",
        "finished"
    ];
    let currentSlide = "modules";
    let doingAjax = false;
    const udbPluginOnboarding = window.udbPluginOnboarding;
    /**
	 * @type {import("tiny-slider").TinySliderInstance} slider - The slider instance.
	 */ let slider;
    function init() {
        if (!page || !buttonsWrapper || !skipButton || !saveButton || !discountNotif || !subscribeButton || !skipDiscount) return;
        setupSlider();
    }
    function setupSlider() {
        slider = window.tns({
            container: ".udb-onboarding-slides",
            items: 1,
            loop: false,
            autoHeight: true,
            controls: false,
            navPosition: "bottom",
            onInit: onSliderInit
        });
    }
    /**
	 * Slider initialization callback
	 *
	 * @param {import("tiny-slider").TinySliderInfo} instance The slider instance.
	 */ function onSliderInit(instance) {
        slider.events.on("indexChanged", onSliderIndexChanged);
        const dotsWrapper = document.querySelector(".onboarding-heatbox .udb-dots");
        if (dotsWrapper && instance.navContainer) dotsWrapper.appendChild(instance.navContainer);
        skipButton?.addEventListener("click", onSkipButtonClick);
        saveButton?.addEventListener("click", onSaveButtonClick);
        subscribeButton?.addEventListener("click", onSubscribeButtonClick);
        skipDiscount?.addEventListener("click", onSkipDiscountClick);
    }
    /**
	 * Event handler for when the slider index changes.
	 *
	 * @param {import("tiny-slider").TinySliderInfo} e The event object.
	 */ function onSliderIndexChanged(e) {
        currentSlide = slideIndexes[e.index];
        if (currentSlide === "modules") onModulesSlideSelected();
        else if (currentSlide === "subscription") onSubscriptionSlideSelected();
        else if (currentSlide === "finished") onFinishedSlideSelected();
    }
    function onModulesSlideSelected() {
        discountNotif?.classList.add("is-hidden");
        buttonsWrapper?.classList.remove("is-hidden");
    }
    function onSubscriptionSlideSelected() {
        discountNotif?.classList.remove("is-hidden");
        buttonsWrapper?.classList.add("is-hidden");
    }
    function onFinishedSlideSelected() {
        discountNotif?.classList.add("is-hidden");
        buttonsWrapper?.classList.add("is-hidden");
    }
    /**
	 * Function to handle the skip button click event.
	 *
	 * @param {MouseEvent} e The event object.
	 */ function onSkipButtonClick(e) {
        switch(currentSlide){
            case "modules":
                // Go to next slide.
                slider.goTo("next");
                break;
            case "subscription":
                // Go to dashboard.
                window.location.href = udbPluginOnboarding?.adminUrl ?? "";
                break;
            default:
                break;
        }
    }
    /**
	 * Function to handle the save button click event.
	 *
	 * @param {MouseEvent} e The event object.
	 */ function onSaveButtonClick(e) {
        if (doingAjax) return;
        startLoading(saveButton);
        $.ajax({
            url: udbPluginOnboarding?.ajaxUrl,
            type: "POST",
            data: {
                action: "udb_plugin_onboarding_save_modules",
                nonce: udbPluginOnboarding?.nonces.saveModules,
                modules: getSelectedModules()
            }
        }).done(function(r) {
            if (!r.success) return;
            slider.goTo("next");
        }).fail(onAjaxFail).always(function() {
            stopLoading(saveButton);
        });
    }
    /**
	 * Function to handle the subscribe button click event.
	 *
	 * @param {MouseEvent} e The event object.
	 */ function onSubscribeButtonClick(e) {
        const nameField = (0, $776ab16a6a692098$export$4e5337e1a9674b6)("#udb-subscription-name");
        const emailField = (0, $776ab16a6a692098$export$4e5337e1a9674b6)("#udb-subscription-email");
        if (doingAjax || !nameField || !emailField) return;
        startLoading(subscribeButton);
        $.ajax({
            url: udbPluginOnboarding?.ajaxUrl,
            type: "POST",
            data: {
                action: "udb_plugin_onboarding_subscribe",
                nonce: udbPluginOnboarding?.nonces.subscribe,
                name: nameField.value,
                email: emailField.value,
                referrer: page?.dataset.udbReferrer ?? ""
            }
        }).done(function(r) {
            if (!r.success) return;
            contentAfterSkipDiscount.forEach(function(content) {
                content.style.display = "none";
            });
            hideSetupSubmenuItem();
            slider.goTo("next");
        }).fail(onAjaxFail).always(function() {
            stopLoading(subscribeButton);
        });
    }
    /**
	 * Function to handle the skip discount button click event.
	 *
	 * @param {MouseEvent} e The event object.
	 */ function onSkipDiscountClick(e) {
        e.preventDefault();
        if (doingAjax) return;
        startLoading(skipDiscount?.parentElement);
        $.ajax({
            url: udbPluginOnboarding?.ajaxUrl,
            type: "POST",
            data: {
                action: "udb_plugin_onboarding_skip_discount",
                nonce: udbPluginOnboarding?.nonces.skipDiscount,
                referrer: page?.dataset.udbReferrer
            }
        }).done(function(r) {
            if (!r.success) return;
            contentAfterSubscribe.forEach(function(content) {
                content.style.display = "none";
            });
            hideSetupSubmenuItem();
            slider.goTo("next");
        }).fail(onAjaxFail).always(function() {
            stopLoading(skipDiscount?.parentElement);
        });
    }
    /**
	 * Function to handle ajax request failure.
	 *
	 * @param {JQueryXHR} jqXHR The ajax request object.
	 */ function onAjaxFail(jqXHR) {
        let errorMesssage = "Something went wrong";
        if (jqXHR.responseJSON && jqXHR.responseJSON.data) errorMesssage = jqXHR.responseJSON.data;
        alert(errorMesssage);
    }
    /**
	 * Function to start loading.
	 *
	 * @param {HTMLElement|null|undefined} button The button element.
	 */ function startLoading(button) {
        doingAjax = true;
        button?.classList.add("is-loading");
    }
    /**
	 * Function to stop loading.
	 *
	 * @param {HTMLElement|null|undefined} button The button element.
	 */ function stopLoading(button) {
        button?.classList.remove("is-loading");
        doingAjax = false;
    }
    function getSelectedModules() {
        const checkboxes = (0, $776ab16a6a692098$export$276904e442ba468d)('.udb-modules-slide .module-toggle input[type="checkbox"]');
        if (!checkboxes.length) return [];
        /**
		 * @type {string[]} modules - The selected modules.
		 */ const modules = [];
        checkboxes.forEach(function(checkbox) {
            const module = checkbox.id.replace("udb_modules__", "");
            if (checkbox.checked) modules.push(module);
        });
        return modules;
    }
    /**
	 * Hide the "Setup" submenu item.
	 */ function hideSetupSubmenuItem() {
        const submenuItems = (0, $776ab16a6a692098$export$c1ead522ca0e4e3c)("#menu-posts-udb_widgets .wp-submenu > li > a");
        if (!submenuItems.length) return;
        for(let i = 0; i < submenuItems.length; i++){
            const link = submenuItems[i];
            if (!(link instanceof HTMLAnchorElement)) continue;
            if (link.href.includes("page=udb_plugin_onboarding")) {
                link.parentElement?.remove();
                break;
            }
        }
    }
    init();
})(jQuery);

})();
//# sourceMappingURL=plugin-onboarding.js.map
